import { useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';

import { ReactElement, useMemo } from 'react';

import { RootState } from '../store';
import { AllowedProfiles } from '../utils/AllowedProfiles';
import GuardRoute from './GuardRoute';
import { routesConfig } from './routesConfig';

const ChatGuard = ({ children }: { children: ReactElement }) => {
  const location = useLocation();
  const profile = useSelector((state: RootState) => state.profile.profileData);
  const isStudent = AllowedProfiles(profile?.perfil?.nome, ['Aluno']);
  const isEducationChildhood =
    profile?.TeacherSegments?.includes('Ensino Infantil') &&
    profile.TeacherSegments.length === 1;

  const isCoordinatorOnlyEI =
    profile?.perfil?.nome?.toLocaleLowerCase() === 'coordenador' &&
    profile?.segmentos?.length === 1 &&
    profile.segmentos[0] === 'EI';

  const shouldBlockEducationChildhoodFeatures =
    isEducationChildhood || isCoordinatorOnlyEI;

  const currentUserProfiles: string[] = [];
  if (isStudent) {
    currentUserProfiles.push('student');
  }
  if (shouldBlockEducationChildhoodFeatures) {
    currentUserProfiles.push('education_childhood');
  }

  const currentPath = useMemo(() => location.pathname + location.search, [location]);

  const activeRoute = useMemo(
    () => routesConfig.find(route => route.path === currentPath),
    [currentPath],
  );

  const isBlocked = useMemo(
    () =>
      activeRoute?.blockedForProfiles?.some(p => currentUserProfiles.includes(p)),
    [activeRoute, currentUserProfiles],
  );

  return <GuardRoute allow={!isBlocked}>{children}</GuardRoute>;
};

const AppRoutes = () => {
  return (
    <Routes>
      {routesConfig.map(route => (
        <Route
          key={route.path}
          path={route.path.split('?')[0]}
          element={
            route.path.includes('?') ? (
              <ChatGuard>{route.element}</ChatGuard>
            ) : (
              route.element
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;
